import { useContext } from 'react';

import type { CdmRootLocationFeatureToggles } from '../../cdm-types';
import { defaultCdmFeatureToggleConfig } from '../../default-config';

import { FeatureToggleConfigContext } from './cdm-use-feature-toggle-config-context';

export const useFeatureToggleConfig = (): {
  config: CdmRootLocationFeatureToggles;
  isLoading: boolean;
} => {
  const { useCdmSelectedLocationContext } = useContext(
    FeatureToggleConfigContext
  );

  const { selectedLocationConfig, isLoading } = useCdmSelectedLocationContext();

  return {
    config:
      selectedLocationConfig?.featureToggles ?? defaultCdmFeatureToggleConfig,
    isLoading,
  };
};
